import React, { Fragment } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { Divider } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';

import { styles } from './styles';
import withRoot from '../../../../withRoot';

interface IHelpProps {
    updateBotText: any
    setOpen: any;
    valueData: any;
}

const promptButtons = [
    'Line 1.1',
    'Line 2.1',
    'Line 3.1',
    'Line 4.1',
];

const TalkTextData1: React.FC<IHelpProps> = ({
    updateBotText,
    setOpen,
    valueData
}) => {
    return (
        <Fragment>
            {valueData && valueData.length === 0 ? promptButtons.map((button: any) => (
                <MenuItem
                    onClick={() => {
                        updateBotText(button);
                        setOpen(false);
                    }}
                    style={{ textAlign: 'center' }}
                >
                    {button}
                    <Divider />
                </MenuItem>
            )) : valueData && valueData.map((button: any) => (
                <MenuItem
                    onClick={() => {
                        updateBotText(button);
                        setOpen(false);
                    }}
                    style={{ textAlign: 'center' }}
                >
                    {button}
                    <Divider />
                </MenuItem>
            ))}
        </Fragment>
    );
};

export default withRoot(withStyles(styles)(TalkTextData1));